import { render, staticRenderFns } from "./AddBordereau.vue?vue&type=template&id=0b5a4faa&"
import script from "./AddBordereau.vue?vue&type=script&lang=js&"
export * from "./AddBordereau.vue?vue&type=script&lang=js&"
import style0 from "./AddBordereau.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddBordereau.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports